import { Store } from 'vuex';
import router from '~/router';
import abilityPlugin from './plugins/ability';
import { buildModule, createRouteModule, createRouteSyncPlugin, ModuleInterface, ModuleState } from './utils';

import admins from './admins';
import areas from './areas';
import audits from './audits';
import campaignType from './campaign-type';
import campaignVisuals from './campaign-visuals';
import campaigns from './campaigns';
import campaignAdditionalMaterials from './campaign-additional-materials';
import campaignSplit from './campaign-split';
import core from './core';
import customFields from './custom-fields';
import dashboard from './dashboard';
import eventLog from './event-log';
import eventTypes from './event-types';
import exports from './exports';
import information from './information';
import library from './library';
import notifications from './notifications';
import planner from './planner';
import poses from './poses';
import printers from './printers';
import products from './products';
import productTypes from './product-types';
import promoItemGroups from './promo-item-groups';
import promoCategories from './promo-categories';
import promos from './promos';
import protocolItem from './protocol-item';
import protocols from './protocols';
import regions from './regions';
import posZones from './pos-zones';
import posTypes from './pos-types';
import releaseNotes from './release-notes';
import settings from './settings';
import tagCategory from './tag-category';
import tags from './tags';
import taskItems from './task-items';
import tasks from './tasks';
import territories from './territories';
import user from './user';
import warehouses from './warehouses';
import campaignOrders from './campaign-orders';
import campaignBriefs from './campaign-briefs';
import campaignSplitFilters from './campaign-split-filters';
import uploadData from './upload-data';

const rootModule = buildModule()
	.withSubmodules({
		...createRouteModule(router),
		admins,
		areas,
		audits,
		campaignVisuals,
		campaignType,
		campaigns,
		campaignAdditionalMaterials,
		campaignSplit,
		campaignSplitFilters,
		campaignOrders,
		campaignBriefs,
		core,
		customFields,
		dashboard,
		eventLog,
		eventTypes,
		exports,
		information,
		library,
		notifications,
		planner,
		poses,
		printers,
		products,
		productTypes,
		promoItemGroups,
		promoCategories,
		promos,
		protocolItem,
		protocols,
		regions,
		posZones,
		posTypes,
		releaseNotes,
		settings,
		tagCategory,
		tags,
		taskItems,
		tasks,
		territories,
		user,
		uploadData,
		warehouses,
	});

export type { UntypedStore } from './utils';
export type TypedStore = ModuleInterface<typeof rootModule>;
export type GetterValue<P extends keyof TypedStore['getters']> = TypedStore['getters'][P];

type TypedState = ModuleState<typeof rootModule>;

const store = createStore({
	...rootModule,
	state: {} as TypedState,
	plugins: [
		createRouteSyncPlugin(router),
		abilityPlugin,
	],
	// strict: true,
});

export default store as Omit<Store<TypedState>, keyof TypedStore> & TypedStore;
